import { render, staticRenderFns } from "./LaboratoryHelpTab.vue?vue&type=template&id=1c716306&"
import script from "./LaboratoryHelpTab.vue?vue&type=script&lang=js&"
export * from "./LaboratoryHelpTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports